import api from './api'
import ErrorService from './errorService'
import Cookies from 'universal-cookie'

export const countryService = {

    getAllCountry: async () => {
        try {
          const cookies = new Cookies()
          const response = await ErrorService.withTimeout(api.get('/Country', {
            headers:{'Authorization': `Bearer ${cookies.get('tokenGcc')}`}
          }))
          return response.data
      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener paises:', error)
          throw error
        }
      },



}